// Facebook post/photo URLs for the 8th Patronal Fiesta gallery. Add new links here.
export const FIESTA_POSTS = [];

export const FIESTA_ALBUM_URL =
  "https://www.facebook.com/media/set?vanity=mabuhayparish&set=a.122118454119447354";

export const PARISH_FB_PAGE = "https://www.facebook.com/mabuhayparish";
